export default {
    index: {
        listagem_conversao_resultado: 'Result Conversion List',
        conversao_resultado_nao_encontrada: 'No result conversions found',
        criar_conversao_resultado: 'Create Result Conversion',
        origem: 'Origin',
        destino: 'Destiny',
        exame: 'Exam',
        editar: 'Edit'
    },
    form: {
        integracao_origem: 'Origin Integration',
        integracao_destino: 'Destiny Integration',
        exame: 'Exam',
        operacao: 'Operation',
        operacao_descricao: 'Operation that will be applied to the result. Examples: + 10 or - 10 or * 10 or / 10',
        status_descricao: 'Result Conversion Status',
        titulo_editar: 'Edit Result Conversion',
        titulo_criar: 'Create New Result Conversion',
        integracao_origem_obrigatoria: 'Origin integration selection is mandatory!',
        integracao_destino_obrigatoria: 'Destiny integration selection is mandatory!',
        exame_obrigatorio: 'Exam selection is mandatory!',
        regra_operacao_obrigatoria: 'In the operation field, only numbers, commas and basic math operators are allowed.',
        criada_sucesso: 'Result Conversion Setup Successfully Created',
        editada_sucesso: 'Result Conversion Configuration Updated Successfully'
    }
}